import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const PixelConversion = asyncComponent({
    resolve: () => import('./PixelConversion'),
});

export default class PixelConversionWrapper extends Component {
    render() {
        return(
            <div>
                <PixelConversion config={this.props.config}/>
            </div>
        );
    }
}

PixelConversionWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
